/*
 * utils.service.ts
 * utms-admin-dashboard
 * 
 * Last Modified: 29.07.2024
 * Modified By: Tetiana Makovii
 * 
 * Created by Tetiana Makovii on 29.07.2024
 * Copyright © 2026 Sonova AG. All rights reserved.
 */

import { Injectable } from '@angular/core';

//@classLog
@Injectable({
  providedIn: 'root'
})
export class UtilsService
{
  static wildcardHCP = "*WildcardHCP"
  static wildcardSupport = "Support"

  constructor() { }

  static getAge(dateOfBirth: Date)
  {
    return new Date(new Date().getTime() - dateOfBirth.getTime()).getUTCFullYear() - 1970
  }

  static isStartsWithSubstring(text: string, substring: string): boolean
  {
    let l_text = text.split(' ')
    let l_result=false
    l_text.forEach(l_word =>
    {
      if (l_word.toLowerCase().startsWith(substring.toLowerCase())) l_result= true
    })
    return l_result
  }


  getRelativeDateTimeWithDaysMonthAgo(timestamp: string): string
  {
    let l_datetime = new Date(timestamp)
    let l_now = new Date()
    let l_delta = ((l_now).getTime() - l_datetime.getTime()) / 3600000
    switch (true)
    {
      case (l_delta < 1): { return "Just now" }
      case (l_delta > 1 && l_delta < 1.5): {

        return "1 hour ago"

      }
      case (l_delta >= 1.5 && l_delta < 24): {
       
          return Math.round(l_delta) + ` ` + "hours ago"
        
      }
      case (l_delta >= 24): {
        let l_deltaTemp = l_delta - l_datetime.getHours() - l_datetime.getMinutes() / 60 - l_datetime.getSeconds() / 3600 - l_datetime.getMilliseconds() / 3600000
        if (l_deltaTemp <= 24)
        {
          return "Yesterday"
        } else
        {
          let l_days = Math.floor((Date.UTC(l_now.getFullYear(), l_now.getMonth(), l_now.getDate()) - Date.UTC(l_datetime.getFullYear(), l_datetime.getMonth(), l_datetime.getDate())) / (1000 * 60 * 60 * 24));
          if (l_days < 31)
          {
           
              return `${ l_days } ` + "days ago"
           
          }
          var l_month = l_days / 30;
          if (l_month < 1.6)
          {
            return "1 month ago"
          }
          else if (l_month <= 12)
          {
           
              return `${ Math.floor(l_month) } ` + "months ago"
            
          }
          else return "More than 1 year ago"
        }
      }
    }
    return ''
  }


}
